import { ReservationOccasion } from '../../../../../services/exports/Constants';

export default {
  updated_details: 'Détails mis à jour',
  previous_details: 'Détails précédents',
  fields: {
    datetime: 'Date :',
    email: 'E-mail :',
    phone_number: 'Numéro de téléphone :',
    customer: 'Client :',
    source: 'Source :',
    guests: 'Invités :',
    comment: 'Commentaire :',
    confirmed_at: 'Confirmé le :',
    status: 'Statut :',
    occasion: 'Occasion :',
    created_at: 'Créé le :',
  },
  status: {
    confirmed: 'Confirmé',
    pending: "En attente d'approbation",
    canceled: 'Annulé',
    canceled_by_customer: 'Annulé par le client',
    rejected: 'Rejeté',
    removed: 'Supprimé',
  },
  buttons: {
    confirm: 'Confirmer',
    reject: 'Rejeter',
    cancel: 'Annuler',
    edit: 'Modifier',
    remove: 'Supprimer',
  },
  occasion: {
    [ReservationOccasion.Birthday]: 'Anniversaire',
    [ReservationOccasion.Anniversary]: 'Anniversaire de mariage',
    [ReservationOccasion.Date]: 'Rendez-vous',
    [ReservationOccasion.SpecialOccasion]: 'Occasion spéciale',
    [ReservationOccasion.BusinessMeal]: "Repas d'affaires",
  },
  remove_reservation_modal: {
    title: 'Êtes-vous sûr de vouloir supprimer la réservation ?',
    buttons: {
      remove: 'Supprimer',
      cancel: 'Annuler',
    },
  },
  response_messages: {
    success: 'Statut de réservation mis à jour. Le client a été notifié.',
    error: 'Échec de la mise à jour du statut. Veuillez réessayer.',
  },
};
